import { ButtonsBox, FileNameBox, CustomButton } from "./styles";

interface CustomButtonsProps {
    filename: string;
    fileRef: any;
    handleFileChange: any;
    onUpload: any;
    onClear: any;
}
const CustomButtons = ({filename, fileRef, handleFileChange, onUpload, onClear}: CustomButtonsProps) => {
    return (
        <ButtonsBox>
            <FileNameBox>{filename}</FileNameBox>
            <input onChange={handleFileChange} ref={fileRef} type="file" hidden />
            <CustomButton onClick={onUpload}>파일 업로드</CustomButton>
            <CustomButton onClick={onClear} >업로드 삭제</CustomButton>
        </ButtonsBox>
    );
};

export default CustomButtons;